import { Button } from "../../Atoms/Button";
import { Pagination } from "../../Atoms/Pagination";
import { Table } from "../../Molecules/Table";
import { FormFilterHolidays } from "../../Molecules/FormFilterHolidays";
import * as S from "./styles";
import { v4 } from "uuid";
import { useHolidays } from "./useHolidays";
import dayjs from "dayjs";

export const HolidaysTemplate = () => {
  const {
    open,
    setOpen,
    isMobile,
    pagination,
    setNumberPage,
    feriados,
    handleClean,
    navigate,
    handleFilter,
    handleDelete,
    canEditHolidays,
  } = useHolidays();

  return (
    <S.Container>
      <h1>Feriados Cadastrados</h1>

      <S.WrapperFilter>
        <S.WrapperButons>
          <Button data-variant-outline onClick={() => setOpen((prev) => !prev)}>
            <img src="/assets/svgs/icon-filter-dark.svg" alt="icone filtro" />
            Filtrar
          </Button>
          {canEditHolidays ? (
            <Button
              data-variant-outline
              onClick={() => navigate("/configuracoes/feriados/cadastro")}
            >
              <img src="/assets/svgs/icon-plus.svg" alt="icone filtro" />
              Cadastrar
            </Button>
          ) : (
            <></>
          )}
        </S.WrapperButons>

        {open && (
          <FormFilterHolidays
            onClean={handleClean}
            onSubmitForm={handleFilter}
          />
        )}
      </S.WrapperFilter>

      <Table.Root>
        <Table.WrapperItems>
          {feriados?.map((i) =>
            isMobile ? (
              <S.ItemMobile key={v4()}>
                <div id="wrapper-elements">
                  <S.TableElement>
                    DIA:
                    <span>{dayjs(i.dia).format("DD/MM/YYYY") || "---"}</span>
                  </S.TableElement>
                  <S.TableElement>
                    TIPO:
                    <span>{i.isDelivery ? "Delivery" : "Loja"}</span>
                  </S.TableElement>
                  <S.TableElement>
                    UF:
                    <span>{i.uf || "---"}</span>
                  </S.TableElement>
                  <S.TableElement>
                    CIDADE:
                    <span>{i.cidade || "---"}</span>
                  </S.TableElement>
                  <S.TableElement>
                    ATENDIMENTO:
                    <span>{i.tipo || "---"}</span>
                  </S.TableElement>
                  <S.TableElement>
                    HORÁRIO:
                    <span>{i.horarioInicial || "---"}</span>
                  </S.TableElement>
                </div>
                <div id="wrapper-icon">
                  {canEditHolidays ? (
                    <img
                      src="/assets/svgs/icon-trash-red.svg"
                      alt="icone lixeira"
                      onClick={() => handleDelete(i.uuid)}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </S.ItemMobile>
            ) : (
              <Table.Item
                key={v4()}
                columns="1fr 1fr 1fr 1fr 1fr 1fr .1fr"
                elements={[
                  <S.TableElement>
                    DIA:
                    <span>{dayjs(i.dia).format("DD/MM/YYYY") || "---"}</span>
                  </S.TableElement>,
                  <S.TableElement>
                    TIPO:
                    <span>{i.isDelivery ? "Delivery" : "Loja"}</span>
                  </S.TableElement>,
                  <S.TableElement>
                    UF:
                    <span>{i.uf || "---"}</span>
                  </S.TableElement>,
                  <S.TableElement>
                    CIDADE:
                    <span>{i.cidade || "---"}</span>
                  </S.TableElement>,
                  <S.TableElement>
                    ATENDIMENTO:
                    <span>{i.tipo || "---"}</span>
                  </S.TableElement>,
                  <S.TableElement>
                    HORÁRIO:
                    <span>{i.horarioInicial || "---"}</span>
                  </S.TableElement>,
                  canEditHolidays ? (
                    <img
                      src="/assets/svgs/icon-trash-red.svg"
                      alt="icone lixeira"
                      onClick={() => handleDelete(i.uuid)}
                    />
                  ) : (
                    <></>
                  ),
                ]}
              />
            )
          )}
        </Table.WrapperItems>
      </Table.Root>

      {feriados?.length > 0 && (
        <Pagination
          maxPageNumbersDisplayed={isMobile ? 3 : 10}
          key={`${Math.random()} - ${pagination}`}
          totalPage={pagination.totalPage}
          totalRegister={pagination.totalPage}
          actualPage={pagination.actualPage}
          setNumberPage={setNumberPage}
        />
      )}
    </S.Container>
  );
};
